import { Edit, useGetOne, useNotify, useRedirect, useUpdate, useRefresh } from 'react-admin';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import BillerMerchantCodeForm from './BillerMerchantCodeForm';

interface MerchantCode {
  id: string;
  merchantCode: string;
  paymentGateway: string;
  merchantId: string;
  clientKey: string;
  secretKey: string;
  userName: string;
  password: string;
}

const BillerMerchantCodeEdit = () => {
  const { id } = useParams<{ id: string }>();
  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const [saveData, setSaveData] = useState<any>(null);
  
  // Log when component mounts and when ID changes
  useEffect(() => {
    console.log('BillerMerchantCodeEdit mounted with ID:', id);
    return () => {
      console.log('BillerMerchantCodeEdit unmounting');
    };
  }, [id]);

  // Add data fetching to see if we're getting the record
  const { data: record, isLoading, error } = useGetOne<MerchantCode>('billerMerchantCodes', { id: id! });
  
  // Log record and errors
  useEffect(() => {
    if (error) {
      console.error('Error fetching record:', error);
      notify('Error loading record', { type: 'error' });
    }
    if (record) {
      console.log('Fetched record:', record);
    }
  }, [record, error, notify]);

  // Handle save with custom logic
  const [update, { isLoading: isUpdating }] = useUpdate();
  
  const handleSave = (data: any) => {
    console.log('Saving data:', data);
    setSaveData(data);
    
    update(
      'billerMerchantCodes',
      { id, data: { ...data, merchantCode: id } },
      {
        onSuccess: (data) => {
          console.log('Save successful:', data);
          notify('Record updated successfully', { type: 'success' });
          refresh();
          redirect('list', 'billerMerchantCodes');
          redirect('list', 'biller/merchantCodes');
        },
        onError: (error: any) => {
          console.error('Error saving record:', error);
          notify('Error updating record', { type: 'error' });
        },
      }
    );
  };

  if (isLoading) {
    console.log('Loading record...');
    return <div>Loading...</div>;
  }

  console.log('Rendering with record:', record);
  console.log('Save data state:', saveData);
  console.log('Is updating:', isUpdating);

  return (
    <Edit 
      resource="billerMerchantCodes" 
      id={id}
      transform={(data: any) => {
        console.log('Transforming data before save:', data);
        return {
          ...data,
          merchantCode: id
        };
      }}
      mutationOptions={{
        onSuccess: (data: MerchantCode) => {
          console.log('Mutation success:', data);
          notify('Record updated successfully', { type: 'success' });
          redirect('list', 'billerMerchantCodes');
        },
        onError: (error: any) => {
          console.error('Mutation error:', error);
          notify('Error updating record', { type: 'error' });
        },
      }}
    >
      <BillerMerchantCodeForm onSubmit={handleSave} />
    </Edit>
  );
};

export default BillerMerchantCodeEdit;
